import {Component, ChangeDetectionStrategy, Input} from '@angular/core';
import {EntityGroupName} from '../../core/dtos/api';
import {DashboardApiService} from '../../core/services/api/dashboard-api.service';
import {map} from 'rxjs/operators';

@Component({
    selector: 'app-non-supported-groups',
    templateUrl: './non-supported-groups.component.html',
    styleUrls: ['./non-supported-groups.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NonSupportedGroupsComponent {
  @Input() supportedGroups: (EntityGroupName | 'non-root-users')[] = [];
  constructor(public dashboardApiService: DashboardApiService) { }

  readonly entityGroupName$ = this.dashboardApiService.currentAccount$.pipe(map(x => x.entity_group_name));

}
